/**
 * @voltxampere/engine — Ground reference DC stamp
 *
 * Ground is a structural marker, not a circuit element. Its single
 * pin pins the connected net to `V = 0` by virtue of that net being
 * compressed out of the MNA system. There is therefore no admittance
 * or RHS contribution to make — this stamp is intentionally a no-op.
 *
 * The stamp still exists (rather than being absent from the registry)
 * so the dispatch loop can call it uniformly without a special-case
 * branch for "ground". It also asserts the structural invariant: a
 * `ground` component must be wired to the canonical ground net.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { ContractViolationError } from "@voltxampere/shared";
import { defineDCStamp } from "../definition.js";
import { getTerminalNetId } from "../terminal-utils.js";
export const groundDCStamp = (ctx, component) => {
    const idx = ctx.nodeIndex(getTerminalNetId(component, "p"));
    if (idx !== -1) {
        throw new ContractViolationError(`groundDCStamp: component "${component.id}" is wired to a non-ground net (planner should pin the ground net before stamping)`);
    }
};
/** Structural marker — no MNA rows or RHS contribution. */
export const groundDCStampDefinition = defineDCStamp("ground", groundDCStamp, []);
//# sourceMappingURL=ground.js.map